export enum ShareRegistryProvider {
    None = 0,
    Automic = 1,
    Xcend = 2
}
